// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ntAa","col":"styles_col__1w5wD","fulfillmentStatus":"styles_fulfillmentStatus__Xh_8B","emailCol":"styles_emailCol__M_a69"};